import { EMPTY_ARRAY, IApplicationState } from '../../../../types/types';
import {TBoardId} from '../../../../types/types';

export const getSelectedLists = (
    state: IApplicationState,
    boardId: TBoardId,
): number[] => {
    return state.clickManager[boardId] ? state.clickManager[boardId].selectedListIds : EMPTY_ARRAY;
};
